<template>
  <div class="main-container">
    <bread-crumb :items="breadcrumbPath" />
    <v-divider />
    <v-flex
      md4
      sm6
      v-cloak
      xs12
    >
      <ManageTeamsTable />
    </v-flex>
  </div>
</template>

<script>

    import {mapGetters} from "vuex";
    import {FETCH_PERSONNEL} from "@/store/person/actions";
    import {FETCH_TEAM, FETCH_TEAM_LIST,} from "@/store/team/actions";
    import ManageTeamsTable from '@/views/ManageTeams/components/ManageTeamsTable.vue';

    export default {

        components: {
            ManageTeamsTable
        },

        data() {
            return {
                breadcrumbPath: [{text: process.env.VUE_APP_SYSTEM_NAME, to: "/"}, {text: 'Manage Teams', to: "manage-teams"}],
                loading: true,
                personnelWithTeamTitle: [],
                selectedPersonnelId: '',
                teamId: '',
                chosenPerson: {},

            };
        },

        computed: {
            ...mapGetters(
            [
                "team",
                "teamList",
                "editStateTeam",
                "personnelInTeamCount",
                "personnelInTeamList",
            ]
            )
        },

        mounted() {
            this.fetchPersonnel();

            if (
            this.$route.params !== undefined
            && this.$route.params.teamId !== undefined) {
                this.teamId = this.$route.params.teamId;
            }

            if (this.teamId > 0) {
                this.fetchTeam();
            }
        },

        methods: {
            fetchPersonnel() {
                this.$store.dispatch(FETCH_PERSONNEL);
            },
            // fetchPersonnelTeams() {
            //     this.$store.dispatch(FETCH_PERSONNEL_TEAM_LIST);
            // },
            fetchTeams() {
                this.$store.dispatch(FETCH_TEAM_LIST);
            },

            fetchTeam() {
                this.$store.dispatch(FETCH_TEAM, this.teamId);
            },

            updateCurrentTeamSelected(teamId) {
                // console.log(teamId);
                this.teamId = teamId;
                this.$router.push({name: 'manage teams', params: {teamId}});
                this.fetchTeam();
            },
        },


    }
</script>

<style scoped>
  #teamsTable {
    width: 100%;
    text-align: left;
    padding-left: 16px;
  }
</style>
